<script lang="ts">
  import { geheZu, router } from '../router.svelte.ts';

  function zuAbschnitt(ereignis: MouseEvent, id: string): void {
    ereignis.preventDefault();
    if (router.pfad !== '/') geheZu('/');
    requestAnimationFrame(() =>
      document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' }),
    );
  }
</script>

<section class="hero tb-gradient">
  <div class="breite">
    <div>
      <span class="hero-vorzeile">Für Privatkunden, Familien, Vereine und kleine Betriebe</span>
      <h1>IT-Hilfe ohne Stress.<br /><span class="akzent">Ohne Fachchinesisch.</span></h1>
      <p class="hero-lead">
        Dein persönlicher IT-Service für Technik-Support, Passwörter und wichtige Dokumente.
      </p>

      <ul class="hero-haken">
        <li><span class="haken">✓</span> Klare Preise</li>
        <li><span class="haken">✓</span> Keine Vertragsfallen</li>
        <li><span class="haken">✓</span> Hilfe auch für Technik-Einsteiger</li>
      </ul>

      <div class="hero-cta">
        <a class="tb-btn-primary gross" href="/#registrieren" onclick={(e) => zuAbschnitt(e, 'registrieren')}>
          Jetzt kostenlos registrieren
        </a>
        <a class="tb-btn-sekundaer gross hell" href="tel:+4975683090137">
          📞 Kostenloses Erstgespräch
        </a>
      </div>
    </div>
  </div>
</section>

<style>
  .tb-btn-sekundaer.hell {
    color: #fff;
    border-color: rgba(255, 255, 255, 0.55);
  }

  .tb-btn-sekundaer.hell:hover {
    background: rgba(255, 255, 255, 0.1);
    border-color: #fff;
  }
</style>
